import { P4 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ButtonSubtitle = styled(P4)`
  flex: 1;
  color: ${themeStyle.varInkMedium};
`;
